module.exports = __webpack_public_path__ + "static/media/car-building.45b40a8d.svg";